<template>
  <div style="margin-top: 30px" id="app">
    <el-row class="panel-group">
      <el-col style="float: left; width: 60%; margin: 0">
        <el-card>
          <div slot="header" class="clearfix">
            <b>快捷菜单</b>
          </div>
          <div class="bg-color-sub" style="background: rgb(236, 245, 255) none repeat scroll 0% 0%">
            <div v-for="(item, index) in buttonList" :key="item.name + index" class="bg-blue-sub-item">
              <el-button type="warning" @click="topage(item.path.replace(/\s*/g, ''))">
                <i :class="item.iconCls"></i>
                {{ item.name }}
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col class="card-panel-col" v-if="allRoutList.filter((e) => e.name == '今日任务').length > 0
        ? true
        : false
        ">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">今日任务</div>
            <span class="card-acuser-num">
              {{
                taskInfo.DayTaskCount > 9
                ? taskInfo.DayTaskCount
                : "0" + taskInfo.DayTaskCount
              }}
            </span>
          </div>
        </div>
      </el-col>
      <el-col class="card-panel-col" v-if="allRoutList.filter((e) => e.name == '今日任务').length > 0
            ? true
            : false
          ">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">今日计划</div>
            <span class="card-acuser-num">
              {{
                taskInfo.DaySumTaskQuantity > 9
                ? taskInfo.DaySumTaskQuantity
                : "0" + taskInfo.DaySumTaskQuantity
              }}
            </span>
          </div>
        </div>
      </el-col>
      <el-col class="card-panel-col" v-if="allRoutList.filter((e) => e.name == '今日任务').length > 0
            ? true
            : false
          ">
        <div class="card-panel extoday">
          <div class="card-panel-description">
            <div class="card-panel-text">今日生产</div>
            <span data-v-6723c96e class="card-panel-num">
              {{
                taskInfo.OutMasterDaySumQuanitty > 9
                ? taskInfo.OutMasterDaySumQuanitty
                : "0" + taskInfo.OutMasterDaySumQuanitty
              }}
            </span>
          </div>
        </div>
      </el-col>
      <el-col :span="12" class="echarts-item" v-if="allRoutList.filter((e) => e.name == '当日耗料图').length > 0
            ? true
            : false
          ">
        <div class="content-title"><el-tag>当日耗料图</el-tag></div>
        <ve-ring :data="ringChartData" :settings="ringChartSettings"></ve-ring>
      </el-col>
      <el-col :span="12" class="echarts-item" v-if="allRoutList.filter((e) => e.name == '工控机库存量').length > 0
        ? true
        : false
        ">
        <el-select v-model="selectStationID" placeholder="选择生产线" @change="selectStation">
          <el-option v-for="item in stationLine" :key="item.Id + '_scx'" :label="item.Name" v-model="item.Id"></el-option>
        </el-select>
        <div class="content-title"><el-tag>工控机库存量(吨)</el-tag></div>
        <ve-histogram :data="plcStock" :settings="histogramChartSettingsWeek"
          :mark-line="histogramChartMarkLine"></ve-histogram>
      </el-col>
      <el-col :span="12" class="echarts-item" v-if="allRoutList.filter((e) => e.name == '库存图').length > 0
        ? true
        : false
        ">
        <!-- 这里开始 -->
        <div>
          <div class="content-title"><el-tag>仓库库存图</el-tag></div>
          <el-row>
            <el-col :span="4">
              <el-select v-model="filters.stockType" @change="getStock" placeholder="请选择">
                <el-option label="Erp库存" :value="0"></el-option>
                <el-option label="工控机库存" :value="100"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select v-show="filters.stockType == 100" v-model="filters.stationLineId" placeholder="请选择"
                @change="getStock">
                <el-option v-for="item in stationLine" :key="item.Id + '_addstation'" :label="item.Name"
                  v-model="item.Id"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click.native="getStock">
                查询
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div style="height: 400px; overflow: hidden; overflow-y: scroll">
          <div v-for="item in list" :key="item.id + '_bc1'">
            <div style="width: 100%; text-align: center; font-size: 30px">
              <el-button type="warning" @click="topage('/Report/ReportStock')">
                <i :class="item.iconCls"></i>
                {{ item.name }}
              </el-button>
            </div>
            <div class="jar-area" v-if="item.data.length > 0">
              <div class="jar" v-for="jar in item.data" :key="jar.WarehouseName + '_' + jar.MatName">
                <div class="jar-image">
                  <div class="l1"></div>
                  <div class="l2"></div>
                  <div class="jar-fill" :style="{
                    height:
                      (jar.MaxQuantity > 0
                        ? Number(jar.Quantity) / jar.MaxQuantity
                        : 0) *
                      100 +
                      '%',
                  }"></div>
                  <div class="r1"></div>
                  <div class="r2"></div>
                </div>
                <div class="jar-top">
                  <div>{{ jar.WarehouseName }}</div>
                  <div class="jar-kou">{{ jar.MatName }}</div>
                </div>
                <div class="jar-middle">
                  <div>{{ (jar.Quantity / 1000).toFixed(2) }}吨</div>
                  <div class="jar-p">
                    {{
                      (
                        (jar.Quantity > 0
                          ? Number(jar.Quantity) / jar.MaxQuantity
                          : 0) * 100
                      ).toFixed(2)
                    }}%
                  </div>
                </div>
                <div class="jar-bottom">
                  <div>{{ Number(jar.MaxQuantity) / 1000 }}吨</div>
                </div>
              </div>
            </div>
            <div style="width: 100%; text-align: center" v-else>无</div>
          </div>
        </div>
        <!-- 这里结束 -->
      </el-col>
      <el-col :span="24" class="echarts-item" v-if="allRoutList.filter((e) => e.name == '周方量柱状图').length > 0
        ? true
        : false
        ">
        <div class="content-title"><el-tag>月产量柱状图</el-tag></div>

        <ve-histogram :data="histogramChartDataWeek" :settings="histogramChartSettingsWeek"
          :mark-line="histogramChartMarkLine"></ve-histogram>
      </el-col>
      
      <el-col class="card-panel-col" style="float: left; width: calc(96% - 430px); margin: 0" v-if="allRoutList.filter((e) => e.name == '今日活跃用户').length > 0
        ? true
        : false
        ">
        <el-card class="welcome-card activeuser note">
          <div slot="header" class="clearfix">
            <span>今日活跃用户</span>
          </div>
          <div class="bg-color-sub" style="background: rgb(236, 245, 255) none repeat scroll 0% 0%">
            <div v-for="(item, index) in welcomeInitData.activeUsers" :key="item.user + index" class="bg-blue-sub-item"
              :style="getBck(index)">
              {{ item.user }}
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import applicationUserManager from "../Auth/applicationusermanager";
import {
  getActiveUsers,
  getRequestApiinfoByWeek,
  getAccessApiByDate,
  getDayTaskInfo,
  getManufactureSubDay,
  getPlcStock,
} from "../api/api";
import { getSysStationLineListPage } from "../api/recipe";
import * as api from "../api/command";
// import {

// } from "../api/report";
export default {
  name: "Welcome",
  data() {
    return {
      list: [],
      stationAndStock: [],
      filters: {
        stockTyoe: 0,
      },
      buttonList: [], //此处作为快捷菜单处理
      allRoutList: [], //此页面所有权限，用于管理页面元素是否显示
      orgId: "",
      stationLine: [],
      selectStationID: "",
      // 图表
      histogramChartDataWeek: {},
      plcStock: {
        columns: [],
        rows: [],
      },

      histogramChartSettingsWeek: { yAxisName: ['m³'] },
      histogramChartMarkLine: {},
      lineChartData7Day: {
        columns: [],
        rows: [],
      },
      lineChartSettings7Day: {
        metrics: ["数量"],
        dimension: ["时间"],
      },
      // 图表
      listLoading: false,
      welcomeInitData: {},

      extend: {
        series: {
          type: 'bar',
          label: {
            normal: {
              show: true,
            },
          },
        },
      },
      extendline: {
        series: {
          type: 'line',
          label: {
            normal: {
              show: true,
            },
          },
        },
      },
      lineChartDataIDS4: {
        columns: [],
        rows: [],
        today: 0,
      },
      lineChartSettings7Day: {
        metrics: ["count"],
        dimension: ["date"],
      },
      lineChartMarkPoint: {
        data: [
          {
            name: "最大值",
            type: "max",
          },
          {
            name: "最小值",
            type: "min",
          },
        ],
      },
      ringChartData: {
        columns: ["物资", "用量", "利润"],
        rows: [],
      },
      ringChartSettings: {
        dimension: "物资",
        metrics: "用量",
      },
      taskInfo: {},
    };
  },
  methods: {
    topage(path) {
      this.$router.push(path);
    },
    getBck(index) {
      return `background: rgb(${43 + index * 20}, ${148 + index * 10
        }, 255) none repeat scroll 0% 0%;`;
    },
    // toLogs() {
    //   this.$router.replace({
    //     path: "/Logs/Index",
    //   });
    // },
    //获取生产线列表
    getSysStationLineList() {
      if (this.orgId == "") {
        if (localStorage.currentOrg) {
          this.orgId = JSON.parse(localStorage.currentOrg).Id;
        } else {
          if (localStorage.sysOrgs) {
            this.orgId = JSON.parse(localStorage.sysOrgs)[0].Id;
          }
        }
      }
      let para = {
        key: this.orgId,
      };
      this.listLoading = true;
      getSysStationLineListPage(para)
        .then((res) => {
          this.stationLine = res.data.response.data;
          if (
            this.selectStationID == "" &&
            res.data.response.data &&
            res.data.response.data.length > 0
          ) {
            this.selectStationID = res.data.response.data[0].Id;
            this.GetPlcStock();
          }
          if (res.data.response.data.length > 0) {
            this.filters.stationLineId = this.stationLine[0].Id;
          } else {
            this.filters.stationLineId = null;
          }
          let para = {};
          let dateStart = new Date().getFullYear() + '-01-01 00:00:00';
          let para1 = { startTime: dateStart };
          if (
            this.allRoutList &&
            this.allRoutList.filter((e) => e.name == "周方量柱状图").length > 0
          ) {

            api.getXHAccessChartYear(para1).then((res) => {
              let rows = [];
              this.histogramChartDataWeek = res.data;
            });
          }
          if (
            this.allRoutList &&
            this.allRoutList.filter((e) => e.name == "7天方量曲线图").length > 0
          ) {
            api.getXHAccessChartYear(para1).then((res) => {
              let rows = [];
              this.histogramChartDataWeek = res.data;
            });
          }

          if (
            this.allRoutList &&
            this.allRoutList.filter((e) => e.name == "今日任务").length > 0
          ) {
            getDayTaskInfo(para).then((res) => {
              this.taskInfo = res.data.response;
            });
          }
          if (
            this.allRoutList &&
            this.allRoutList.filter((e) => e.name == "当日耗料图").length > 0
          ) {
            getManufactureSubDay(para).then((res) => {
              var rwoValue = [];
              if (res.data.response) {
                res.data.response.map((e) => {
                  rwoValue.push({
                    物资: e.MatName,
                    用量: Number(e.Quantity).toFixed(2),
                  });
                });
                this.ringChartData.rows = rwoValue;
              }
            });
          }
          if (
            this.allRoutList &&
            this.allRoutList.filter((e) => e.name == "库存图").length > 0
          ) {
            this.getStock();
          }
        })
        .finally(() => { });
    },
    //生产线选择
    selectStation(id) {
      this.selectStationID = id;
      this.GetPlcStock();
    },
    GetPlcStock() {
      let para = {
        stationLineId: this.selectStationID,
      };
      if (
        this.allRoutList &&
        this.allRoutList.filter((e) => e.name == "工控机库存量").length > 0
      ) {
        getPlcStock(para)
          .then((res) => {
            if (res && res.data.response.rows) {
              this.plcStock.columns = res.data.response.columns;
              this.plcStock.rows = JSON.parse(res.data.response.rows);
            } else {
              this.plcStock.rows = [];
            }
          })
          .finally(() => { });
      }
    },
    getStock() {
      let para = this.filters;
      let _this = this;
      api.GetStockReport(para).then((res) => {
        if (res && res.data && res.data.success) {
          let result = [];
          let stationLine = JSON.parse(JSON.stringify(this.stationLine));
          stationLine.push({
            id: null,
          });
          stationLine.forEach((line) => {
            result.push({
              id: line.Id ? line.Id : "-1",
              name: line.Id ? line.Name : "未定义生产线",
              data: res.data.response.filter((x) => x.StationLineID == line.Id),
            });
          });
          this.list = result;
        } else {
          this.list = [];
        }
      });
    },
  },
  mounted() {
    let isrequest = true;
    //获取权限
    if (localStorage.router) {
      var allRouter = JSON.parse(localStorage.router);
      if (allRouter) {
        var thisRouter = allRouter.filter((e) => e.name == "首页");
        if (
          thisRouter &&
          thisRouter.length > 0 &&
          thisRouter[0].children.length > 0
        ) {
          //路由长度大于5，则为快捷按钮
          this.buttonList = thisRouter[0].children.filter(
            (e) => e.IsButton == true && e.IsHide == false && e.path.length > 5
          ); /// console.log(JSON.parse(localStorage.router));
          //路由长度小于5，则为其他功能权限点
          this.allRoutList = thisRouter[0].children.filter(
            (e) => e.IsButton == true && e.IsHide == true && e.path.length < 5
          );
        }
      }
    }

    if (this.orgId == "") {
      if (localStorage.currentOrg) {
        this.orgId = JSON.parse(localStorage.currentOrg).Id;
      } else {
        if (localStorage.sysOrgs) {
          this.orgId = JSON.parse(localStorage.sysOrgs)[0].Id;
        }
      }
    }
    var curTime = new Date();
    if (window.localStorage.TokenExpire) {
      var expiretime = new Date(Date.parse(window.localStorage.TokenExpire));
      if (curTime >= expiretime) {
        if (global.IS_IDS4) {
          applicationUserManager.login();
        } else {
          isrequest = false;
          this.$router.push("/login");
        }
      }
    } else {
      if (global.IS_IDS4) {
        applicationUserManager.login();
      } else {
        isrequest = false;
        this.$router.push("/login");
      }
    }
    // getActiveUsers({}).then((res) => {
    //   this.welcomeInitData = res.data.response;
    // });
    if (isrequest) {
      this.getSysStationLineList();
    }
  },
};
</script>

<style scoped>
.bg-blue-sub-item {
  max-width: 120px !important;
  height: 50px;
  float: left;
  color: #fff;
  font-size: 15px;
  line-height: 50px;
  padding: 0 10px;
}

.note .text {
  font-size: 14px;
}

.note .item {
  margin-bottom: 18px;
}
</style>

<style scoped>
.panel-group {
  margin-top: 18px;
}

.card-panel-col {
  margin-bottom: 32px;
  width: 115px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-right: 2%;
  float: right;
}

.card-panel {
  height: 108px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
}

.card-panel .card-panel-icon-wrapper {
  color: #fff;
}

.card-panel .card-panel .icon-people {
  background: #40c9c6;
}

.card-panel .card-panel .icon-message {
  background: #36a3f7;
}

.card-panel .card-panel .icon-money {
  background: #f4516c;
}

.card-panel .card-panel .icon-shopping {
  background: #34bfa3;
}

.card-panel .icon-people {
  color: #40c9c6;
}

.card-panel .icon-message {
  color: #36a3f7;
}

.card-panel .icon-money {
  color: #f4516c;
}

.card-panel .icon-shopping {
  color: #34bfa3;
}

.card-panel .card-panel-icon-wrapper {
  float: left;
  margin: 14px 0 0 14px;
  padding: 16px;
  transition: all 0.38s ease-out;
  border-radius: 6px;
}

.card-panel .card-panel-icon {
  float: left;
  font-size: 48px;
}

.card-panel .card-panel-description {
  float: left;
  font-weight: bold;
  margin-left: 30px;
  margin-top: 20px;
}

.card-panel .card-panel-description .card-panel-text {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
}

.card-panel .card-panel-description .card-panel-num {
  font-size: 36px;
  color: #f4516c;
}

.extoday {
  cursor: pointer;
}

.card-acuser-num {
  font-size: 36px;
  color: #40c9c6;
}

@media (max-width: 550px) {}
</style>
<style lang="less" scoped>
#app {
  width: 100%;
  overflow-y: auto;
  background-size: cover;
}

.jar-area {
  font-family: "Microsoft YaHei";
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 10px;

  .jar {
    user-select: none;
    width: 100px;
    text-align: center;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin: auto 20px;

    .jar-image {
      position: absolute;
      height: 140px;
      width: 100px;
      top: 40px;
      z-index: -1;
      overflow: hidden;
      background: url(../assets/guanzi.png) no-repeat;
      background-size: cover;

      &:before {
        content: "";
        display: block;
        height: 132px;
        width: 92px;
        position: absolute;
        //border: 4px solid #000;
        top: 0;
        left: 0;
        z-index: 99;
      }

      .l1,
      .l2,
      .r1,
      .r2 {
        content: "";
        display: block;
        border: 30px solid #fff;
        border-color: transparent transparent #fff transparent;
        position: absolute;
        bottom: 0;
        left: -30px;
        z-index: 999;

        &.l2 {
          //border: 35px solid #000;
          border-color: transparent transparent #000 transparent;
          z-index: 998;
          left: -35px;
        }

        &.r1 {
          right: -30px;
          left: initial;
        }

        &.r2 {
          left: initial;
          right: -35px;
          //border: 35px solid #000;
          border-color: transparent transparent #000 transparent;
          z-index: 998;
        }
      }

      .jar-fill {
        height: 100%;
        position: absolute;
        background: #2383e561;
        width: 96%;
        bottom: 0;
      }
    }
  }
}
</style>
